module.exports = __webpack_public_path__ + "static/img/app-slide-show1.03ade24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/app-slide-show1.png
// module id = gg9v
// module chunks = 44